import { adminHttpClient } from '../../commons/adminHttpClient'

export type TriggerJobRequest = {
  jobId: string
  data: string
}

const triggerJob = (request: TriggerJobRequest): Promise<void> => {
  return adminHttpClient.post('Csi/ScheduledJobs', request)
}

export default triggerJob
